import { Inject, Injectable, PLATFORM_ID, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HelpersService } from './helpers.service';
import { Subtree, TranslationPath } from '../models/node';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Taxonomy } from '../models/view-filters.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Injectable()
export class NodeService extends HelpersService {
  private isNew = true;
  public breadCrumb: any;
  public level = 0;
  public breadCrumbFound: boolean = false;
  public header: any;
  public queryParamsPreview: string = `timePreview=${new Date().getTime()}`;
  public searchItemsBS: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public searchItems$: Observable<any> = this.searchItemsBS.asObservable();
  public onChangeHeader = new EventEmitter();
  public hashMapSocialPngWhite: any = {
    Twitter: './assets/images/social-icon/white/x.png',
    Instagram: './assets/images/social-icon/white/instagram.svg',
    Facebook: './assets/images/social-icon/white/facebook.svg',
    LinkedIn: './assets/images/social-icon/white/linkedin.svg',
    Youtube: './assets/images/social-icon/white/youtube.svg',
    Radio: './assets/images/social-icon/white/radio.svg',
    TikTok: './assets/images/social-icon/white/tikTok.svg',
    Podcast: './assets/images/social-icon/white/podcast.svg',
  };
  public hashMapSocialPngGreen: any = {
    Twitter: './assets/images/social-icon/green/x.png',
    Instagram: './assets/images/social-icon/green/instagram.svg',
    Facebook: './assets/images/social-icon/green/facebook.svg',
    LinkedIn: './assets/images/social-icon/green/linkedin.svg',
    Youtube: './assets/images/social-icon/green/youtube.svg',
    Radio: './assets/images/social-icon/green/radio.svg',
    TikTok: './assets/images/social-icon/green/tiktok.svg',
    Podcast: './assets/images/social-icon/green/podcast.svg',
  };
  public nodeVersionTS: any;

  constructor(
    protected override http: HttpClient,
    protected override router: Router,
    @Inject(PLATFORM_ID) protected override platformId: Object,
    protected override cookieService: CookieService,
    protected override title: Title,
    protected override translate: TranslateService,
    protected override meta: Meta,
    protected override modalService: NgbModal,
    protected override viewportScroller: ViewportScroller,
    @Inject(DOCUMENT) protected override doc: Document
  ) {
    super(
      http,
      router,
      platformId,
      cookieService,
      title,
      translate,
      meta,
      modalService,
      viewportScroller,
      doc
    );
  }

  public get urlApi() {
    if (!this.isBrowser && environment.urlApiToProxy) {
      return environment.urlApiToProxy;
    } else {
      return environment.urlApi;
    }
  }

  public get queryParamTs() {
    // return `tsCache=${new Date().getTime()}`;
    return `tsCache=1`;
  }

  public get queryParamNodeVersionTs() {
    if (this.nodeVersionTS) {
      return `&nodeVersionTS=${this.nodeVersionTS}`;
    } else {
      return ``;
    }
  }

  public getNode(routeUrl: string, preview = false): Observable<any> {
    let url = preview
      ? `${this.urlApi}${routeUrl}?${this.queryParamsPreview}&_format=json`
      : `${this.urlApi}${routeUrl}?_format=json`;
    return this.http.get(url, this.getHTTPHeadersNode(preview)).pipe(
      map((res: any) => {
        return res;
      }),

      catchError((error) => {
        return this.handleError(error, preview);
      })
    );
  }

  public getTranslationPath(
    langcode: string,
    nid: number
  ): Observable<TranslationPath[]> {
    const url = `${this.urlApi}/${langcode}/translation/path?nid=${nid}&_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res as TranslationPath[];
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getRow(
    id: string,
    lang: string,
    preview = false,
    repeat = false
  ): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/view/row?id=${id}&_format=json&${this.queryParamsPreview}${this.queryParamNodeVersionTs}`
      : `${this.urlApi}/${lang}/view/row?id=${id}&_format=json${this.queryParamNodeVersionTs}`;

    if (repeat) {
      url = url + `&overridecache=true`;
    }

    return this.http.get(url, this.getHTTPHeaders(preview)).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getResultsPerPage(
    lang: string,
    view: string,
    page: number,
    preview = false,
    innerText?: string
  ): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/view/${view}/news?page=${page}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${view}/news?page=${page}&_format=json`;
    if (innerText && innerText.length) {
      url = `${url}&inner-text=${innerText}&text=${innerText}`;
    }
    url = view === 'content' ? url : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders(preview)).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getLastResults(
    lang: string,
    view: string,
    preview = false
  ): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/view/${view}/News?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${view}/News?_format=json`;
    url = view === 'content' ? url : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders(preview)).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  //NON USATA
  public getItems(
    urlApi: string,
    filters: any,
    preview = false
  ): Observable<any> {
    let url = preview
      ? `${this.urlApi}${urlApi}?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}${urlApi}?_format=json`;
    if (filters.page) {
      url = `${url}&page=${filters.page}`;
    }
    return this.http.get(url, this.getHTTPHeaders(preview)).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getHeader(lang: string, preview = false): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/custom-rest/header?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/custom-rest/header?_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        this.header = res;
        this.onChangeHeader.emit(res);
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getFooter(lang: string, preview = false): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/custom-rest/footer?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/custom-rest/footer?_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  decodeObject(obj: any) {
    let objDecoded = JSON.parse(JSON.stringify(obj));
    return objDecoded;
  }

  encodeObject(obj: any) {
    let objDecoded = JSON.parse(encodeURIComponent(JSON.stringify(obj)));
    return objDecoded;
  }

  // Funzione per ottenere un breadcrumb (sotto forma di array di nodi) dato un link.
  getTreeFromPath(link: string, menu: any): any {
    // Controlla se il menu è un array.
    if (Array.isArray(menu)) {
      for (let menuItem of menu) {
        // Chiama ricorsivamente la funzione getTreeFromPath per ogni elemento dell'array.
        let result = this.getTreeFromPath(link, menuItem);
        if (result) {
          return result;
        }
      }
      // Se il link non è stato trovato in nessuno degli elementi dell'array, restituisci null.
      return null;
    }
    // Decodifica l'oggetto del menu corrente.
    let menuDecoded = this.decodeObject(menu);
    // Confronta il link dell'oggetto del menu corrente con il link cercato, rimuovendo il prefisso API se presente.
    if (this.removeApiPrefixFromLink(menuDecoded.link) === link) {
      // Se il link corrisponde, restituisci un array contenente solo l'oggetto del menu corrente.
      return [menuDecoded];
    }
    // Se l'oggetto del menu corrente ha un sotto-albero (subtree), cerca il link nei figli.
    else if (menuDecoded.subtree) {
      let children = menuDecoded.subtree;
      for (let child of children) {
        // Chiama ricorsivamente la funzione getTreeFromPath per cercare il link nel sotto-albero.
        let result: any = this.getTreeFromPath(link, child);
        // Se il link è stato trovato nel sotto-albero, aggiungi l'oggetto del menu corrente all'inizio dell'array di risultati.
        if (result) {
          result.unshift(menuDecoded);
          // Restituisci l'array di risultati contenente il percorso completo.
          return result;
        }
      }
    }
  }

  removeApiPrefixFromLink(link: string): string {
    let newLink = link;
    if (typeof link === 'string' && this.isBrowser) {
      if (link.includes(window.origin)) {
        newLink = link.replace(window.origin, '');
      } else if (link.startsWith('https://') || link.startsWith('http://')) {
        let url = new URL(link);
        newLink = url.pathname;
      }
      if (newLink.includes('?')) {
        newLink = newLink.split('?')[0];
      }
    }
    return newLink;
  }

  getPageLevel(link: string, menu: any) {
    let path = this.getTreeFromPath(link, menu);
    if (path) {
      return path.length;
    }
    return null;
  }

  foundPath(path: any, menu: Subtree[]): any {
    let i = 0;
    for (let voice of menu) {
      if (voice.link === path) {
        this.breadCrumb.push(voice);
        this.breadCrumbFound = true;
        break;
      } else if (voice.subtree.length) {
        if (!this.breadCrumbFound) {
          this.breadCrumb.push(voice);
          this.level++;
          this.foundPath(path, voice.subtree);
        } else {
          break;
        }
      }
      i++;
    }
  }

  public getRowTypeView(
    lang: string,
    objView: string,
    typeView: string,
    preview = false,
    nid?: any
  ) {
    let url = nid
      ? `${this.urlApi}/${lang}/view/${typeView}/${objView}?nid=${nid}&_format=json`
      : `${this.urlApi}/${lang}/view/${typeView}/${objView}?_format=json`;
    url = preview ? `${url}&${this.queryParamsPreview}` : url;
    url =
      typeView === 'content' ? url : `${url}${this.queryParamNodeVersionTs}`;
    url = url + this.queryParamNodeVersionTs;
    return this.http.get(url, this.getHTTPHeaders(preview)).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getCalendarResult(from: string, to: string, lang: string) {
    let url = `${this.urlApi}/${lang}/view/calendar/eventi?eventi-from=${from}&eventi-to=${to}&_format=json${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getNodeNews(nid: number, preview = false, lang: string) {
    const url = preview
      ? `${this.urlApi}/${lang}/view/content/news?nid=${nid}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/content/news?nid=${nid}&_format=json`;
    return this.http.get(url, this.getHTTPHeaders(preview)).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getViewFilters(lang: string): Observable<any> {
    const url = `${this.urlApi}/${lang}/custom-rest/view-filters?_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        this.viewFilters = res;
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getView(
    lang: string,
    tipo_view: string,
    oggetto_view: string,
    queryParams: string,
    pageNumber: number,
    preview = false
  ): Observable<any> {
    const queryParam =
      queryParams !== ''
        ? `?${queryParams}&page=${pageNumber}&`
        : `?page=${pageNumber}&`;
    let url = preview
      ? `${this.urlApi}/${lang}/view/${tipo_view}/${oggetto_view}${queryParam}_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${tipo_view}/${oggetto_view}${queryParam}_format=json`;
    url =
      tipo_view === 'content' ? url : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getViewCategories(
    lang: string,
    tipo_view: string,
    oggetto_view: string,
    queryParams: string,
    pageNumber = 0
  ): Observable<any> {
    const queryParam = `?${queryParams}`;
    let url = `${this.urlApi}/${lang}/view/${tipo_view}/${oggetto_view}${queryParam}page=${pageNumber}&_format=json`;
    url =
      tipo_view === 'content' ? url : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getAvaiableTaxonomies(
    lang: string,
    queryParamTs: any
  ): Observable<any> {
    const url = `${this.urlApi}/${lang}/view/available-taxonomies?_format=json&tsCache=${queryParamTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        this.taxonomies = res;
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getTaxonomyForView(blockView: any, filter?: string) {
    let result: any[] = [];
    if (blockView.view_filter_id && this.viewFilters && this.taxonomies) {
      for (const filter of this.viewFilters[blockView.view_filter_id]) {
        if (
          filter.filter_type !== 'default' &&
          filter.filter_type !== 'default[]'
        ) {
          result = [...result, this.setResultTaxonomies(filter)];
        } else {
          result = [
            ...result,
            this.setResultTaxonomiesDefaultOnView(
              blockView,
              filter.filter_name
            ),
          ];
        }
      }
    }
    return result;
  }

  private setResultTaxonomies(filterView: any): any {
    let resultTemp: any[] = [];
    let filterName = filterView.filter_name.replaceAll('_', ' ');
    filterName = filterName.replace('à', 'a');
    const taxonomiesFiltered = this.taxonomies.filter(
      (taxonomy: Taxonomy) =>
        taxonomy &&
        taxonomy.vocabulary &&
        filterName === taxonomy.vocabulary.toLocaleLowerCase().replace('à', 'a')
    );
    // LOG
    resultTemp = [...resultTemp, { [filterName]: taxonomiesFiltered }];
    return resultTemp;
  }

  private setResultTaxonomiesDefaultOnView(
    generalView: any,
    filterName: string
  ): any {

    let resultTemp: any[] = [];
    // LOG
    if (generalView[filterName] && generalView[filterName].length) {
      for (const el of generalView[filterName]) {
        let objTemp = this.taxonomies.find(
          (taxonomy: Taxonomy) => Number(taxonomy.term_id) === el.id
        );
        objTemp = {
          ...objTemp,
          vocabulary: this.toNormalText(objTemp.vocabulary),
        };
        resultTemp = [...resultTemp, objTemp];
      }

      return resultTemp;
    }
  }

  public getNewListViewFiltered(
    lang: string,
    field_oggetto_view: string,
    taxonomies_universita: any[],
    nameTaxonomy: string,
    field_type_view: string,
    preview = false
  ): Observable<any> {
    for (const taxonomy of taxonomies_universita) {
      this.stringView += `${nameTaxonomy}%5B%5D=${taxonomy.id}&`;
    }
    let url = preview
      ? `${this.urlApi}/${lang}/view/${field_type_view}/${field_oggetto_view}&${this.stringView}?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${field_type_view}/${field_oggetto_view}&${this.stringView}?_format=json`;
    url =
      field_type_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getRelatedViewNews(
    lang: string,
    field_oggetto_view: string,
    taxonomies_universita: any[],
    nid: string,
    preview = false
  ) {
    let stringTaxonomy: string = '';
    taxonomies_universita.forEach((el, idx) => {
      if (idx < taxonomies_universita.length - 1) {
        stringTaxonomy += `area%5B%5D=${el.id}&`;
      } else {
        stringTaxonomy += `area%5B%5D=${el.id}`;
      }
    });
    let url = preview
      ? `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-area?${stringTaxonomy}&nid=${nid}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-area?${stringTaxonomy}&nid=${nid}&_format=json`;
    url =
      field_oggetto_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getRelatedViewEvents(
    lang: string,
    field_oggetto_view: string,
    taxonomies_universita: any[],
    nid: string,
    preview = false
  ) {
    let stringTaxonomy: string = '';
    taxonomies_universita.forEach((el, idx) => {
      if (idx < taxonomies_universita.length - 1) {
        stringTaxonomy += `area%5B%5D=${el.id}&`;
      } else {
        stringTaxonomy += `area%5B%5D=${el.id}`;
      }
    });
    let url = preview
      ? `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-area?${stringTaxonomy}&nid=${nid}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-area?${stringTaxonomy}&nid=${nid}&_format=json`;
    url =
      field_oggetto_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getRelatedViewAvvisiAutore(
    lang: string,
    field_oggetto_view: string,
    author_id: string,
    preview = false
  ) {
    let url = preview
      ? `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-author?author=${author_id}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-author?author=${author_id}&_format=json`;
    url =
      field_oggetto_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getRelatedViewAvvisiCorso(
    lang: string,
    field_oggetto_view: string,
    taxonomies_corso_laurea: any[],
    nid: string,
    preview = false
  ) {
    let stringTaxonomy: string = '';
    taxonomies_corso_laurea.forEach((el, idx) => {
      if (idx < taxonomies_corso_laurea.length - 1) {
        stringTaxonomy += `degree%5B%5D=${el.id}&`;
      } else {
        stringTaxonomy += `degree%5B%5D=${el.id}`;
      }
    });
    let url = preview
      ? `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-degree?${stringTaxonomy}&nid=${nid}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${field_oggetto_view}/related-degree?${stringTaxonomy}&nid=${nid}&_format=json`;
    url =
      field_oggetto_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getNewListViewFilteredWithString(
    lang: string,
    field_type_view: string,
    field_oggetto_view: string,
    dataStringFiltered: string,
    preview = false
  ): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/view/${field_type_view}/${field_oggetto_view}&${dataStringFiltered}?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${field_type_view}/${field_oggetto_view}&${dataStringFiltered}?_format=json`;
    url =
      field_type_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public setStringToViewFiltered(taxonomies: any[], filter: any): string {
    let strTax: string = '';
    if (taxonomies && taxonomies.length) {
      for (const taxonomy of taxonomies) {
        if (filter.filter_type.indexOf('[]')) {
          strTax += `${filter.filter_name}%5B%5D=${taxonomy.id}&`;
        } else {
          strTax += `${filter.filter_name}=${taxonomy.id}&`;
        }
      }
    }
    return strTax;
  }

  private toNormalText(str: string): string {
    let string = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    string = string.replace(' ', '_').toLowerCase();
    return string;
  }

  public getRestDocentiCorso(
    lang: string,
    param: string,
    nid: string,
    preview = false
  ): Observable<any> {
    const url = preview
      ? `${this.urlApi}/${lang}/custom-rest/${param}/${nid}?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/custom-rest/${param}/${nid}?_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getPersonaRicercaScientifica(
    lang: string,
    id_ricerca_scientifica: string,
    preview = false
  ): Observable<any> {
    const url = preview
      ? `${this.urlApi}/${lang}/custom-rest/ricerca-scientifica/${id_ricerca_scientifica}?_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/custom-rest/ricerca-scientifica/${id_ricerca_scientifica}?_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getVeiwNoBlock(
    lang: string,
    oggetto_view: string,
    related: string,
    query: string,
    author: string = 'redazione',
    preview = false
  ): Observable<any> {
    let url = preview
      ? `${this.urlApi}/${lang}/view/${oggetto_view}/${related}?${query}=${author}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/view/${oggetto_view}/${related}?${query}=${author}&_format=json`;
    // const url = `${this.urlApi}/${lang}/view/${oggetto_view}/${related}?${query}=${author}&_format=json`;
    url =
      oggetto_view === 'content'
        ? url
        : `${url}${this.queryParamNodeVersionTs}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getAttivitaDidattica(
    lang: string,
    aaOffID: number,
    adLogID: number,
    cdsCod: string,
    pdsCod: string,
    adCod: String,
    preview = false
  ): Observable<any> {
    const url = preview
      ? `${this.urlApi}/${lang}/custom-rest/attivita-didattica/${aaOffID}/${adLogID}?cdsCod=${cdsCod}&pdsCod=${pdsCod}&adCod=${adCod}&_format=json&${this.queryParamsPreview}`
      : `${this.urlApi}/${lang}/custom-rest/attivita-didattica/${aaOffID}/${adLogID}?cdsCod=${cdsCod}&pdsCod=${pdsCod}&adCod=${adCod}&_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getSearch(lang: string, text: string, page: number = 0) {
    const url = `${this.urlApi}/${lang}/view/content/search?${text}&page=${page}&_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        if (res?.rows?.length) {
          res.rows = res.rows.filter((r:any) => r.field_is_almost_full !== "true");
        }
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getRicercaScientifica(userId: string) {
    const url = `https://ricercascientifica.lumsa.it/layout/set/curriculum?user=${userId}`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  public getNewsletter(lang: string) {
    const url = `${this.urlApi}/${lang}/custom-rest/notification-registration?_format=json`;
    return this.http.get(url, this.getHTTPHeaders()).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }
}
